import { useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import stl from "./DmanProgram.module.css";
import SingleDmanBox from "./SingleDmanBox";

import { useLang } from "@/common/Contexts/LanguageContext";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";

const DmanProgram = ({ qualitySection, g4_data }) => {
  const { t } = useTranslation();
  const { createUrl } = useHelpers();
  const [ShowPopUp, setShowPopUp] = useState(false);
  const lang = useLang();
  return (
    <>
      <div className={stl.container}>
        {lang === "ar" ? (
          <img
            src={CDN_LINK + "/assets/images/uspMainDT.svg"}
            alt="title"
            loading="eager"
            width={"227px"}
            height={"80px"}
          />
        ) : (
          <img
            src={CDN_LINK + "/assets/images/GuaranteedENNew.svg"}
            alt="title"
            width={"227px"}
            height={"80px"}
          />
        )}
        {/* <strong className="m-hide">
          {t("برنامج ضمان سيارات المستعمل من سيارة", {
            ns: "web_post_view",
          })}
        </strong> */}
        <div className={stl.dmanOptions}>
          {qualitySection?.usps.map((item, idx) => {
            return (
              <SingleDmanBox
                key={"myDman" + idx}
                icn={item.icon}
                text={item.title}
                content={item.contant}
                g4_data={g4_data}
              />
            );
          })}
        </div>
        <button
          className={stl.infoDman}
          onClick={() => {
            setShowPopUp(true);
            trackEvents("usp_view", {
              ...g4_data,
              usp_type: t("اعرف المزيد عن برنامج ضمان السيارات من سيارة", {
                ns: "web_post_view",
              }),
            });
          }}
        >
          {t("اعرف المزيد عن برنامج ضمان السيارات من سيارة", {
            ns: "web_post_view",
          })}
        </button>
      </div>
      <BottomSheetPopup
        show={ShowPopUp}
        onClose={() => {
          setShowPopUp(false);
        }}
        className={stl.customPostViewPopup}
      >
        <div className={stl.mainDmanPopUpDP}>
          <img
            src={
              qualitySection &&
              qualitySection.popup &&
              qualitySection.popup.main_img
            }
            alt="image"
          />
          <div className={stl.mainPopupInfpDP}>
            {qualitySection &&
              qualitySection.popup &&
              qualitySection.popup.items &&
              Object.entries(qualitySection?.popup?.items).map((item, idx) => {
                return (
                  <div key={"myDmanDiv" + idx}>
                    <img src={item[1].icon} alt="icon" />
                    <div>
                      <strong>{item[1].title.replace(/100/g, "200")}</strong>
                      <p>{item[1].contant.replace(/100/g, "200")}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <div className={stl.termsAndConditions}>
          <a
            href={createUrl("/car-purchase-terms-conditions")}
          >
            {t("تطبق الشروط والأحكام", { ns: "web_post_view" })}
          </a>
        </div>
      </BottomSheetPopup>
    </>
  );
};

export default DmanProgram;
